import Flex from 'typescript-styled-flex'
import styled, { css, ITheme } from '../../../../theme'
import isLink from '../../../../theme/styles/isLink'
import { IWithSize } from '../../Calendar/Calendar'

export const shadowStyles = css`
  height: ${(props: ITheme & IWithSize) =>
    props.theme.calendar.header.height * props.size}px;
  background-color: #fff;
  border-right: 1px solid ${({ theme }: ITheme) => theme.colors.palette.greyTwo};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
  padding: 0 0.5em;
`

const FilterButton = styled(Flex.withComponent('a') as any)<any>`
  ${isLink};
  ${shadowStyles};

  width: ${(props: ITheme & IWithSize) =>
    props.theme.calendar.room.width * props.size}px;
  z-index: 25;
  position: relative;
`

export default FilterButton
